import { Component, computed, input, signal } from '@angular/core';
import { AdminModalComponent } from '../../admin';

const TABLE_PREVIEW_MAX_CHARS = 50;

@Component({
  selector: 'app-lead-message-preview',
  standalone: true,
  imports: [AdminModalComponent],
  template: `
    @if (message().trim()) {
      <div
        class="lead-message-preview"
        [class.lead-message-preview--profile]="variant() === 'profile'"
      >
        <p class="lead-message-preview__text">{{ previewText() }}</p>
        @if (isTruncated()) {
          <button type="button" class="lead-message-preview__link cg-admin-link" (click)="openModal()">
            {{ expandLabel() }}
          </button>
        }
      </div>

      @if (modalOpen()) {
        <app-admin-modal [title]="modalTitle()" size="lg" (closed)="closeModal()">
          <p class="lead-message-preview__full">{{ message() }}</p>
        </app-admin-modal>
      }
    }
  `,
  styles: `
    .lead-message-preview {
      margin-top: 0.125rem;
    }

    .lead-message-preview--profile {
      margin-top: 0.625rem;
      max-width: 42rem;
      margin-inline: auto;
    }

    .lead-message-preview__text {
      margin: 0;
      font-size: 0.8125rem;
      line-height: 1.45;
      color: #64748b;
      word-break: break-word;
    }

    .lead-message-preview--profile .lead-message-preview__text {
      font-size: 0.875rem;
      color: #475569;
    }

    .lead-message-preview__link {
      margin-top: 0.25rem;
      padding: 0;
      border: 0;
      background: none;
      font: inherit;
      font-size: 0.8125rem;
      cursor: pointer;
    }

    .lead-message-preview--profile .lead-message-preview__link {
      display: inline-block;
      font-size: 0.875rem;
    }

    .lead-message-preview__full {
      margin: 0;
      white-space: pre-wrap;
      word-break: break-word;
      line-height: 1.5;
      color: var(--cg-color-text-primary);
    }
  `,
})
export class LeadMessagePreviewComponent {
  readonly message = input.required<string>();
  readonly modalTitle = input('Message');
  readonly expandLabel = input('Show details');
  readonly variant = input<'inline' | 'profile'>('inline');

  readonly modalOpen = signal(false);

  readonly isTruncated = computed(() => this.message().trim().length > TABLE_PREVIEW_MAX_CHARS);

  readonly previewText = computed(() => {
    const text = this.message().trim();
    if (text.length <= TABLE_PREVIEW_MAX_CHARS) return text;
    return `${text.slice(0, TABLE_PREVIEW_MAX_CHARS).trimEnd()}...`;
  });

  openModal(): void {
    this.modalOpen.set(true);
  }

  closeModal(): void {
    this.modalOpen.set(false);
  }
}
